import React from 'react';
import CustomDropDown from 'jsx/elements/buttons/CustomDropDown';
import Spinner from 'jsx/elements/spinner';
import { usePortfolioTranslation as useLocale } from 'jsx/hooks/useTranslation';

import { useMonitoring } from 'components/MonitorProvider';
import NoMonitoringBanner from 'components/NoMonitoringBanner';

import MonitoringChanges from './MonitoringChanges';
import PaymentBehavior from './PaymentBehavior';
import './index.less';
import DashboardOverview from './DashboardOverview';

export default function Dashboard() {
  const { t } = useLocale();
  const { selected, monitors, selectMonitor, status } = useMonitoring();

  const monitorItems = monitors.map((item) => ({
    name: item.name,
    onClick: () => selectMonitor(item),
    key: item.monitorId,
  }));

  if (!selected) {
    if (status === 'loaded') {
      return (
        <>
          <h1>{t('dashboard_heading')}</h1>
          <NoMonitoringBanner />
        </>
      );
    }
    return <Spinner center />;
  }
  return (
    <>
      <div className="dashboard-section-header">
        {/* <h1>{t('dashboard_heading')}</h1> */}
        {monitors.length > 1 && <CustomDropDown title={selected.name} items={monitorItems} />}
      </div>
      <DashboardOverview />
      <div className="grid">
        <div className="col s1of1 text-left" style={{ paddingTop: 13 }}>
          <span className="icon icon-info2 text-blue" style={{ marginRight: 10 }} />{' '}
          {t('creditScore_COVID_company_disclamer')} <br />
          <a href={t('creditScore_COVID_News_url')} target="_blank" rel="noopener noreferrer">
            {t('creditScore_COVID_News_link_text')}
          </a>
        </div>
      </div>
      <PaymentBehavior monitor={selected} />
      <MonitoringChanges monitorId={selected.monitorId} />
    </>
  );
}
